import { render } from "./Establishments.vue?vue&type=template&id=c191d0d2"
import script from "./Establishments.vue?vue&type=script&lang=js"
export * from "./Establishments.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arkane/Dev/Projects/Web/ecole-alpha.proj/ecole-alpha.2024-2025.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.34_vue@3.3.8_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__